import { MaterialType } from "../../../types/materials";
import { otherMaterial } from "../../forms/forms-fields/materials-form-fields";
import { ProductFinderFiltersFormTypes } from "./types";

export const EMPTY_OPTION_VALUE = "";

export const defaultProductFinderFilters: ProductFinderFiltersFormTypes = {
  materials: {
    [MaterialType.Glass]: false,
    [MaterialType.Materia]: false,
    [MaterialType.Wood]: false,
    [MaterialType.Stone]: false,
    [MaterialType.Metal]: false,
    [otherMaterial]: false,
  },
  techSheetFieldsSlugs: {},
  machiningTypeId: EMPTY_OPTION_VALUE,
};
